import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TeamPreviewComponent} from './team-preview.component';
import {DirectivesModule} from '../../../directives/directives.module';
import {PipesModule} from '../../../pipes/pipes.module';

@NgModule({
  declarations: [TeamPreviewComponent],
  imports: [
    CommonModule,
    DirectivesModule,
    PipesModule
  ],
  exports: [TeamPreviewComponent]
})
export class TeamPreviewModule { }
